import { render, staticRenderFns } from "./Communication.vue?vue&type=template&id=2365d5a8&scoped=true&"
import script from "./Communication.vue?vue&type=script&lang=js&"
export * from "./Communication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2365d5a8",
  null
  
)

export default component.exports